
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.333 6.666h0a.667.667 0 01.652.527l.015.162V12.5h4a.666.666 0 01.14 1.319l-.163.014h-4.644 0a.666.666 0 01-.652-.527l-.015-.162V7.333a.667.667 0 01.667-.667zM12.5.833a11.167 11.167 0 110 22.333 11.167 11.167 0 010-22.333zm0 1.333a9.833 9.833 0 100 19.667 9.833 9.833 0 000-19.667z","fill":"#FF5064","stroke":"#FF5064"}})])
          )
        }
      }
    